import React from 'react';
import { Grid, Box, Hidden } from '@material-ui/core';
import '../../main.css';
import HeaderSection from '../../components/reusableComponents/HeaderSection';
import ResetPasswordForm from '../../form/ResetPasswordForm';
import SuccessModal from '../../components/reusableComponents/SuccessModal';
import ErrorModal from '../../components/reusableComponents/ErrorModal';
import Footer from './Footer';
const ResetPassword = () => {
	return (
		<>
			<HeaderSection id={1} />
			<div
				style={{ background: '#0c2f55', color: 'white', marginTop: 50 }}
				id='ticket2'>
				<Grid container>
					<Grid item xs={1}></Grid>
					<Grid item xs={7}>
						<h1>Reset Password</h1>
					</Grid>
					<Grid item xs={4}></Grid>
				</Grid>
			</div>
			<Grid container style={{ paddingLeft: 20 }}>
				<Hidden only={['xs', 'sm']}>
					<Grid item xs={4}></Grid>
				</Hidden>

				<Grid item xs={12} id='ticket' lg={4}>
					<Box
						style={{
							backgroundColor: '#FF F',
							boxShadow: '0px 0px 50px -35px rgb(0 0 0 / 40%)',
							padding: 20,
						}}>
						<ResetPasswordForm />
					</Box>
				</Grid>
				<Hidden only={['xs', 'sm']}>
					<Grid item xs={4}></Grid>
				</Hidden>
			</Grid>
			<Footer />
			<SuccessModal />
			<ErrorModal />
		</>
	);
};

export default ResetPassword;
